var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.card.isDone)?_c('router-link',{attrs:{"to":{
    name: 'LegoCardProcess',
    params: { process: 'Validar', cardId: _vm.card.id },
  }}},[_c('LegoBtn',{class:{ success: _vm.card.acceptTask, fail: _vm.card.acceptTask == 0 }},[_c('span',[_c('i',{staticClass:"fa-solid fa-hands"})]),_vm._v(" "+_vm._s(_vm.card.isValidate ? "Validado" : "Validar")+" ")])],1):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }